import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  card: {
    padding: theme.spacing(1.5),
    marginBottom: 10,
    '&:last-child': {
      marginBottom: 0
    }
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    rowGap: 8,
    marginBottom: theme.spacing(1)
  },
  title: {
    flex: '1 1 160px',
    minWidth: 0
  },
  name: {
    fontWeight: 700,
    wordBreak: 'break-word'
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    marginLeft: 'auto',
    paddingLeft: theme.spacing(1)
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(1, 2)
  },
  fullWidth: {
    gridColumn: '1 / -1',
    wordBreak: 'break-all'
  },
  label: {
    display: 'block',
    color: theme.palette.text.secondary
  }
}));

const isEmpty = value => value === null || value === undefined || value === '';

const ClientRecordCards = props => {
  const { records, fields, renderLeading, renderTrailing } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {(records || []).map(record => (
        <Card className={classes.card} key={record.id} variant="outlined">
          <div className={classes.header}>
            <div className={classes.title}>
              <Typography className={classes.name} variant="subtitle1">
                {record.name}
              </Typography>
              <Typography color="textSecondary" variant="caption">
                #{record.id}
              </Typography>
            </div>
            <div className={classes.actions}>
              {renderLeading ? renderLeading(record) : null}
              {renderTrailing ? renderTrailing(record) : null}
            </div>
          </div>
          <div className={classes.grid}>
            {fields.map(field => {
              const value = field.render(record);
              return (
                <div
                  className={field.fullWidth ? classes.fullWidth : undefined}
                  key={field.label}>
                  <Typography className={classes.label} variant="caption">
                    {field.label}
                  </Typography>
                  <Typography component="div" variant="body1">
                    {isEmpty(value) ? '—' : value}
                  </Typography>
                </div>
              );
            })}
          </div>
        </Card>
      ))}
    </div>
  );
};

ClientRecordCards.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      fullWidth: PropTypes.bool,
      label: PropTypes.string.isRequired,
      render: PropTypes.func.isRequired
    })
  ).isRequired,
  records: PropTypes.array,
  renderLeading: PropTypes.func,
  renderTrailing: PropTypes.func
};

ClientRecordCards.defaultProps = {
  records: []
};

export default ClientRecordCards;
